import type {
  ProductAddModalPreviewCategory,
  ProductAddModalScenarioContent,
} from '@front-platform/content-builder';
import { DoodProductModel } from '@core/models/product.model';
import { PRODUCT_ADD_MODAL_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import type { Cb2PreviewScenarioPayload } from '@core/services/cb2-preview/cb2-preview-protocol';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { resolvePreviewScenarioForBloc } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';

export type ProductAddModalPreviewView = {
  product: DoodProductModel;
  categories: readonly ProductAddModalPreviewCategory[];
};

/** Studio preview supplies a composable product. Outside preview, the store does. */
export function resolveProductAddModalPreview(input: {
  isPreview: boolean;
  scenarios: Readonly<Record<string, Cb2PreviewScenarioPayload>>;
  blocKey: string | null | undefined;
}): ProductAddModalPreviewView | null {
  if (!input.isPreview) {
    return null;
  }

  const content = previewScenarioData<ProductAddModalScenarioContent>(
    resolvePreviewScenarioForBloc(input.scenarios, input.blocKey, PRODUCT_ADD_MODAL_COMPONENT),
    PRODUCT_ADD_MODAL_COMPONENT,
  );

  if (!content?.product) {
    return null;
  }

  return {
    product: content.product as unknown as DoodProductModel,
    categories: content.categories ?? [],
  };
}
